// Car body types (tip caroserie) mapped to brands. This is a simplified mapping for demo purposes.
// For a real app, expand this mapping as needed.
const brandBodyTypes = {
  'Abarth': ['Hatchback', 'Convertible'],
  'Acura': ['Sedan', 'SUV'],
  'Alfa Romeo': ['Sedan', 'SUV', 'Hatchback', 'Coupe', 'Convertible'],
  'Aston Martin': ['Coupe', 'Convertible'],
  'Audi': ['Sedan', 'SUV', 'Hatchback', 'Coupe', 'Convertible', 'Wagon'],
  'Bentley': ['Sedan', 'Coupe', 'Convertible', 'SUV'],
  'BMW': ['Sedan', 'SUV', 'Hatchback', 'Coupe', 'Convertible', 'Wagon'],
  'Bugatti': ['Coupe'],
  'Buick': ['Sedan', 'SUV'],
  'Cadillac': ['Sedan', 'SUV', 'Coupe'],
  'Chevrolet': ['Sedan', 'SUV', 'Hatchback', 'Coupe', 'Convertible', 'Pickup'],
  'Chrysler': ['Sedan', 'Van', 'Convertible'],
  'Citroën': ['Hatchback', 'Van', 'Wagon', 'SUV'],
  'Cupra': ['Hatchback', 'SUV'],
  'Dacia': ['SUV', 'Hatchback', 'Van'],
  'Daewoo': ['Sedan', 'Hatchback'],
  'Daihatsu': ['Hatchback', 'SUV'],
  'Dodge': ['Sedan', 'SUV', 'Coupe', 'Pickup', 'Van'],
  'DS': ['Hatchback', 'SUV'],
  'Ferrari': ['Coupe', 'Convertible'],
  'Fiat': ['Hatchback', 'Van', 'Convertible', 'SUV'],
  'Ford': ['Sedan', 'SUV', 'Hatchback', 'Coupe', 'Convertible', 'Pickup', 'Van'],
  'Genesis': ['Sedan', 'SUV'],
  'GMC': ['SUV', 'Pickup'],
  'Honda': ['Sedan', 'SUV', 'Hatchback', 'Coupe', 'Van'],
  'Hummer': ['SUV'],
  'Hyundai': ['Sedan', 'SUV', 'Hatchback', 'Wagon'],
  'Infiniti': ['Sedan', 'SUV', 'Coupe'],
  'Isuzu': ['SUV', 'Pickup'],
  'Jaguar': ['Sedan', 'SUV', 'Coupe', 'Convertible'],
  'Jeep': ['SUV', 'Pickup'],
  'Kia': ['Sedan', 'SUV', 'Hatchback', 'Wagon'],
  'Lada': ['Sedan', 'Hatchback', 'SUV'],
  'Lamborghini': ['Coupe', 'Convertible', 'SUV'],
  'Lancia': ['Sedan', 'Hatchback', 'Wagon'],
  'Land Rover': ['SUV'],
  'Lexus': ['Sedan', 'SUV', 'Coupe'],
  'Lincoln': ['Sedan', 'SUV'],
  'Lotus': ['Coupe', 'Convertible'],
  'Maserati': ['Sedan', 'SUV', 'Coupe', 'Convertible'],
  'Mazda': ['Sedan', 'SUV', 'Hatchback', 'Wagon', 'Convertible'],
  'McLaren': ['Coupe', 'Convertible'],
  'Mercedes': ['Sedan', 'SUV', 'Hatchback', 'Coupe', 'Convertible', 'Wagon', 'Van'],
  'MG': ['Hatchback', 'SUV'],
  'Mini': ['Hatchback', 'Convertible', 'SUV'],
  'Mitsubishi': ['Sedan', 'SUV', 'Hatchback', 'Pickup'],
  'Nissan': ['Sedan', 'SUV', 'Hatchback', 'Pickup', 'Coupe'],
  'Opel': ['Sedan', 'SUV', 'Hatchback', 'Wagon', 'Van'],
  'Peugeot': ['Sedan', 'SUV', 'Hatchback', 'Wagon', 'Van'],
  'Polestar': ['Sedan', 'SUV'],
  'Pontiac': ['Sedan', 'Coupe', 'Hatchback'],
  'Porsche': ['Coupe', 'SUV', 'Convertible'],
  'RAM': ['Pickup', 'Van'],
  'Renault': ['Sedan', 'SUV', 'Hatchback', 'Wagon', 'Van'],
  'Rolls-Royce': ['Sedan', 'Coupe', 'Convertible'],
  'Rover': ['Sedan', 'Hatchback'],
  'Saab': ['Sedan', 'Hatchback', 'Convertible', 'Wagon'],
  'Seat': ['Sedan', 'SUV', 'Hatchback', 'Wagon'],
  'Skoda': ['Sedan', 'SUV', 'Hatchback', 'Wagon'],
  'Smart': ['Hatchback', 'Convertible'],
  'SsangYong': ['SUV'],
  'Subaru': ['Sedan', 'SUV', 'Hatchback', 'Wagon', 'Coupe'],
  'Suzuki': ['Sedan', 'SUV', 'Hatchback', 'Wagon'],
  'Tesla': ['Sedan', 'SUV'],
  'Toyota': ['Sedan', 'SUV', 'Hatchback', 'Wagon', 'Pickup', 'Coupe'],
  'Volkswagen': ['Sedan', 'SUV', 'Hatchback', 'Wagon', 'Convertible', 'Van'],
  'Volvo': ['Sedan', 'SUV', 'Wagon', 'Hatchback'],
  'Other': ['Other']
};

export default brandBodyTypes;
